import { FC } from 'react';
import classNames from 'classnames';
import { Link } from '@inertiajs/react';

import { CloseSvg } from '@/Components/Icons/CloseSvg';
import { ModalView } from '@/Components/ModalView';
import { ChevronRightSvg } from '@/Components/Icons/ChevronRightSvg';

type PlayerTypeModalProps = {
    onClose: () => void;
};

export const PlayerTypeModal: FC<PlayerTypeModalProps> = ({ onClose }) => {
    const options = [
        {
            isStandIn: false,
            id: 'overlay',
            title: 'Overlay',
            text: 'Float your Flow on top of the page content, accessed from the corner of the screen.',
            bgClassName: 'group-hover:scale-75',
            contentClassName: 'group-hover:scale-110',
            bgElement: (
                <img
                    src="/img/player-inline-bg.png"
                    style={{
                        transform: 'scale(1.4, 1.4) translate(0 , 0)',
                    }}
                    className="w-full h-full object-cover"
                />
            ),
            contentElement: (
                <img
                    src="/img/player-overlay-preview.png"
                    className="object-cover"
                    style={{
                        height: '70px',
                    }}
                />
            ),
        },
        {
            isStandIn: false,
            id: 'inline',
            title: 'Inline',
            text: 'Show your Flow inside the page body, placed amongst existing content and elements.',
            bgClassName: 'group-hover:scale-105 scale-150',
            contentClassName: 'group-hover:scale-110',
            bgElement: (
                <img
                    src="/img/player-overlay-bg.png"
                    className="w-full h-full object-cover "
                />
            ),
            contentElement: (
                <img
                    src="/img/player-inline-preview.png"
                    className="object-cover"
                    style={{
                        height: '70px',
                    }}
                />
            ),
        },
    ];

    return (
        <ModalView
            maxWidth="lg"
            onClose={onClose}
            contentContainerClassName="py-4 text-brand-ocean flex flex-col justify-center items-center">
            <div className="flex flex-row items-center w-full px-6">
                <div className="flex-1 text-heading-four !font-bold text-brand-ocean text-left">
                    Choose your Flow Type
                </div>
                <button
                    className="p-2 -mr-1 transition-all rounded-md hover:cursor-pointer hover:bg-neutral-mid"
                    onClick={onClose}>
                    <CloseSvg className="[&_path]:stroke-1 [&_path]:stroke-brand-ocean" />
                </button>
            </div>
            <div className="flex flex-col gap-y-3 mt-2 mx-4" onClick={onClose}>
                {options.map((option, index) => {
                    return (
                        <Link
                            href={route('flows.create', {
                                template: option.id,
                            })}
                            aria-label={option.title}
                            tabIndex={0}
                            key={option.title}
                            className="group flex flex-row items-center hover:cursor-pointer hover:bg-neutral-mid px-2 py-2 transition-all duration-300 rounded-lg select-none">
                            <div className="relative min-w-36 min-h-24 rounded-md overflow-hidden flex items-center justify-center border border-gray-10">
                                <div
                                    className={classNames(
                                        'transition-all duration-300 flex-1 absolute w-full h-full',
                                        option.bgClassName,
                                    )}>
                                    {option.bgElement}
                                </div>
                                <div
                                    className={classNames(
                                        'transition-all duration-300 z-10',
                                        option.contentClassName,
                                    )}>
                                    {option.contentElement}
                                </div>
                            </div>
                            <div className="ml-4">
                                <div className="flex flex-row flex-wrap gap-x-2 items-center mb-2">
                                    <div className="text-body-text-15 text-brand-ocean">
                                        {option.title}
                                    </div>
                                    <div
                                        className={classNames(
                                            'py-1 px-2 text-small-text-10 rounded-full hidden',
                                            {
                                                'opacity-0': !option.isStandIn,
                                            },
                                        )}
                                        style={{
                                            backgroundColor:
                                                'rgba(214, 206, 235, 1)',
                                            color: 'rgba(82, 39, 204, 1)',
                                        }}>
                                        AI Stand-In
                                    </div>
                                </div>
                                <div className="text-small-text-13 text-gray-80">
                                    {option.text}
                                </div>
                            </div>
                            <div className="ml-4 mr-2">
                                <ChevronRightSvg
                                    className="stroke-1 stroke-gray-80 opacity-80"
                                    width={10}
                                    height={10}
                                    fill="rgba(130, 130, 130, 1)"
                                />
                            </div>
                        </Link>
                    );
                })}
            </div>
        </ModalView>
    );
};
